import React, { type FunctionComponent } from "react";
import { DeliverySetting } from "@/data/DeliverySetting.ts";

type Card = {
  zone: DeliverySetting
}
const DetailZoneCard: FunctionComponent<Card> = ({ zone }) => {
  console.log(`render detail`, zone)
  return (
    <div className="shadow-[0px_4px_10px_rgba(0,_0,_0,_0.2)] min-w-[350px] flex flex-row text-black rounded-[8px] bg-[#fff] border-[#2979ff] border-[1px] border-solid flex flex-col items-start justify-center p-[16px] gap-[8px] z-[0] relative">
      {zone.zoneName &&
        <div className="self-stretch flex flex-row items-center justify-start gap-[4px]">
          <div className="font-bold text-lg">{zone.zoneName}</div>
        </div>}
      <div className="self-stretch flex flex-row items-center justify-start gap-[4px]">
        <div className="font-medium">Postal Code: {zone.postalCode}</div>
      </div>
      <div className="self-stretch flex flex-row items-center justify-start gap-[4px]">
        <div className="font-medium">Delivery Cost: {zone.cost || 0}</div>
      </div>
      <div className="self-stretch flex flex-row items-center justify-start gap-[4px]">
        <div className="font-medium">Min Order Value: {zone.minOrderValue || 0}</div>
      </div>
    </div>
  );
};

export default DetailZoneCard;
